import StartEndDates from "~/components/elements/StartEndDates";
import Contributors from "~/components/elements/Contributors";
import ProjectType from "~/components/projectCards/ProjectType";

export interface ProjectItemProps {
  project: any;
  theme?: string;
  placeholdersHidden: boolean;
  projectCardLocation: string;
}

export default function ProjectCardBottomContributors({
  project,
  theme,
  placeholdersHidden,
  projectCardLocation,
}: ProjectItemProps) {
  return (
    <div
      className={`flex justify-between border-t pt-3 ${
        theme === "dark" ? "border-gray-700" : null
      }`}
    >
      <>
        <Contributors contributors={project.contributors_full} />
        <div className="flex flex-col items-end text-right text-xs font-semibold">
          <ProjectType
            type={project.type}
            placeholdersHidden={placeholdersHidden}
          />
          <StartEndDates
            project={project}
            theme={theme}
            location={projectCardLocation}
            placeholdersHidden={placeholdersHidden}
          />
        </div>
      </>
    </div>
  );
}
